module.exports = __webpack_public_path__ + "img/chat_b.99fb54e4.png";